export default "__VITE_ASSET__BgSUcYw7__"